var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("AppBreadCrumb", {
        attrs: { paths: [{ title: "Fatura Yönetimi" }], select: true },
      }),
      _vm._v(" "),
      _vm.updatingCard
        ? _c("UpdateCardModal", {
            on: {
              cancel: function ($event) {
                _vm.updatingCard = false
              },
              create: _vm.updateCard,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.updatingBilling
        ? _c("UpdateBillingModal", {
            on: {
              cancel: function ($event) {
                _vm.updatingBilling = false
              },
              create: _vm.updateBilling,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.trialSkipModal
        ? _c("TrialSkipModal", {
            on: {
              reject: function ($event) {
                _vm.trialSkipModal = false
              },
              confirm: _vm.skipTrial,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.billModal
        ? _c("CreateInvoiceModal", {
            on: {
              cancel: function ($event) {
                _vm.billModal = false
              },
              create: _vm.createInvoice,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "billing" } }, [
        _vm.trialInfo.remainingDays > 0
          ? _c("div", { staticClass: "trial-information" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "skip-now",
                  on: {
                    click: function ($event) {
                      _vm.trialSkipModal = true
                    },
                  },
                },
                [_vm._v("Hemen Atla")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "billing-section" }, [
          _c("div", { staticClass: "title" }, [_vm._v("Mevcut Planlar")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "current-plans" },
              _vm._l(_vm.planTypes, function (type) {
                return _c("CurrentPlanCard", {
                  key: type,
                  attrs: {
                    type: type,
                    "plan-action": _vm.currentPlans[type],
                    plan:
                      _vm.currentPlans[type] &&
                      _vm.plans[_vm.currentPlans[type].plan.planId],
                  },
                  on: { "show-plans": _vm.showPlans },
                })
              }),
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              display: "grid",
              "grid-template-columns": "50% 50%",
              "column-gap": "10px",
              "margin-top": "30px",
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "billing-section",
                staticStyle: { width: "100%" },
              },
              [
                _c(
                  "div",
                  { staticClass: "content", staticStyle: { width: "100%" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card",
                        staticStyle: {
                          background: "white",
                          "border-radius": "15px",
                          padding: "25px",
                          border: "none",
                        },
                      },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Fatura Adresleri"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "bills-content" }, [
                          _c("div", { staticClass: "bills" }, [
                            _vm.billingDetail &&
                            _vm.billingDetail.billingAddress
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "bill",
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "top",
                                      "justify-content": "space-between",
                                      padding: "20px 0px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "padding-right": "30px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.billingDetail
                                                    .billingType == "company"
                                                    ? _vm.billingDetail.name
                                                    : _vm.billingDetail.name +
                                                        " " +
                                                        _vm.billingDetail
                                                          .surname
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.billingDetail.billingAddress
                                              ) +
                                              " -\n                                            " +
                                              _vm._s(
                                                _vm.billingDetail.billingCountry
                                              ) +
                                              "/" +
                                              _vm._s(
                                                _vm.billingDetail.billingCity
                                              ) +
                                              "\n                                        "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid rgb(236, 75, 29)",
                                  color: "rgb(236, 75, 29)",
                                  display: "flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                  padding: "10px 15px",
                                  "border-radius": "100px",
                                  "user-select": "none",
                                  cursor: "pointer",
                                  "margin-top": "10px",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.updatingBilling = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "material-icons",
                                    staticStyle: {
                                      "font-size": "16px",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        edit\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.billingDetail &&
                                        _vm.billingDetail.billingAddress
                                        ? "Düzenle"
                                        : "Yeni Adress Ekle"
                                    ) +
                                    "\n                                "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "billing-section",
                staticStyle: { width: "100%" },
              },
              [
                _c(
                  "div",
                  { staticClass: "content", staticStyle: { width: "100%" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "card",
                        staticStyle: {
                          background: "white",
                          "border-radius": "15px",
                          padding: "25px",
                          border: "none",
                        },
                      },
                      [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n                            Ödeme Yöntemleri\n                            "
                          ),
                          _c(
                            "div",
                            { staticClass: "iyzico-pay" },
                            [_c("IyzicoPay")],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "bills-content" }, [
                          _c("div", { staticClass: "bills" }, [
                            _vm.billingDetail && _vm.billingDetail.binNumber
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "bill",
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "space-between",
                                      padding: "20px 0px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "padding-right": "30px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "payment-method" },
                                              [
                                                _c("DynamicSvg", {
                                                  attrs: {
                                                    name: _vm.formatCardType(
                                                      _vm.billingDetail
                                                        .cardAssociation
                                                    ),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "bold",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm.formatCardNumber(
                                                          _vm.billingDetail
                                                            .binNumber
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "rgb(160, 160, 160)",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm.formatCardType(
                                                          _vm.billingDetail
                                                            .cardAssociation
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  border: "1px solid rgb(236, 75, 29)",
                                  color: "rgb(236, 75, 29)",
                                  display: "flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                  padding: "10px 15px",
                                  "border-radius": "100px",
                                  "user-select": "none",
                                  cursor: "pointer",
                                  "margin-top": "10px",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.updatingCard = true
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "material-icons",
                                    staticStyle: {
                                      "font-size": "16px",
                                      "margin-right": "5px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        edit\n                                    "
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.billingDetail &&
                                        _vm.billingDetail.binNumber
                                        ? "Düzenle"
                                        : "Yeni Kart Ekle"
                                    ) +
                                    "\n                                "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "billing-section", staticStyle: { width: "100%" } },
          [
            _c(
              "div",
              { staticClass: "content", staticStyle: { width: "100%" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "card",
                    staticStyle: {
                      background: "white",
                      "border-radius": "15px",
                      padding: "25px",
                      border: "none",
                    },
                  },
                  [
                    _c("div", { staticClass: "title" }, [
                      _c("div", [
                        _vm._v(
                          "\n                            Gelecek Fatura\n                            "
                        ),
                        _c("span", { staticStyle: { "font-size": "18px" } }, [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.getForecastDetails().invoiceDate) +
                              ")"
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "bills-content" }, [
                      _c("div", { staticClass: "running-invoice" }, [
                        _c("div", { staticClass: "running-invoice-detail" }, [
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "running-invoice-detail-title" },
                              [_vm._v("Fatura Dönemi")]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.getForecastDetails().dateBetween)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "running-invoice-detail-title" },
                              [_vm._v("Kesim Tarihi")]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.getForecastDetails().leftTime)),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "running-invoice-price-details" },
                          [
                            _c(
                              "div",
                              { staticClass: "running-invoice-price-detail" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "running-invoice-detail-title",
                                  },
                                  [_vm._v("Ay Sonu Tahmini Tutar")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "price" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.seperateWithCommas(
                                          _vm
                                            .getForecastDetails()
                                            .endOfMonthForecast.toFixed(2)
                                        )
                                      ) +
                                      "₺\n                                    "
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "running-invoice-price-detail" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "running-invoice-detail-title",
                                  },
                                  [_vm._v("Mevcut Tutar")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "price" }, [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.seperateWithCommas(
                                          _vm
                                            .getForecastDetails()
                                            .untilToday.toFixed(2)
                                        )
                                      ) +
                                      "₺\n                                    "
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.showRunningInvoiceDetails
                        ? _c(
                            "div",
                            { staticClass: "running-invoice-details" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "running-invoice-details-title",
                                },
                                [_vm._v("Detaylar")]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.getForecastDetails().details,
                                function (plan) {
                                  return _c(
                                    "div",
                                    { staticClass: "detail-content" },
                                    [
                                      _c("hr", {
                                        staticStyle: {
                                          padding: "0",
                                          margin: "4px 0px",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "justify-content": "space-between",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-weight": "bold",
                                                color: "black",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.title[plan.type] ||
                                                      plan.type
                                                        .split("-")
                                                        .map(function (c) {
                                                          return (
                                                            c[0].toUpperCase() +
                                                            c
                                                              .slice(1)
                                                              .toLowerCase()
                                                          )
                                                        })
                                                        .join(" ")
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-weight": "bold",
                                                color: "black",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    ~~(
                                                      plan.totalPrice.price || 0
                                                    )
                                                  ) +
                                                  "₺\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("hr", {
                                        staticStyle: {
                                          padding: "0",
                                          margin: "4px 0px",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        _vm._l(
                                          Object.values(plan.details),
                                          function (detail) {
                                            return _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "detail-content-child",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "align-items": "center",
                                                      "justify-content":
                                                        "space-between",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "font-weight": "bold",
                                                          color: "black",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                                                    - " +
                                                              _vm._s(
                                                                detail.plan
                                                                  .title
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                detail.plan
                                                                  .altTitle
                                                              ) +
                                                              "\n                                                    " +
                                                              _vm._s(
                                                                detail.plan
                                                                  .type ==
                                                                  "supsis"
                                                                  ? "(" +
                                                                      detail
                                                                        .planAction
                                                                        .details
                                                                        .agentCount +
                                                                      " Agent) " +
                                                                      (_vm.getFreeAgentCount(
                                                                        detail
                                                                          .plan
                                                                          .features
                                                                      )
                                                                        ? "(First " +
                                                                          _vm.getFreeAgentCount(
                                                                            detail
                                                                              .plan
                                                                              .features
                                                                          ) +
                                                                          " Agent(s) Free)"
                                                                        : "")
                                                                  : detail.plan
                                                                      .type ==
                                                                      "whatsapp" ||
                                                                    detail.plan
                                                                      .type ==
                                                                      "whatsap-business"
                                                                  ? "(" +
                                                                    detail
                                                                      .planAction
                                                                      .details
                                                                      .whatsappChannel +
                                                                    " Whatsapp Kanal)"
                                                                  : ""
                                                              )
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              detail.startDate
                                                            ) +
                                                            " - " +
                                                            _vm._s(
                                                              detail.endDate
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "font-weight": "bold",
                                                          color: "black",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              plan.type ==
                                                                "chatbot"
                                                                ? detail.sessionCount +
                                                                    " Session"
                                                                : (detail.price ||
                                                                    0) > 0
                                                                ? _vm.seperateWithCommas(
                                                                    (
                                                                      detail.price ||
                                                                      0
                                                                    ).toFixed(2)
                                                                  ) + "₺"
                                                                : "0₺"
                                                            ) +
                                                            "\n                                            "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "align-items": "flex-end",
                                    "justify-content": "flex-end",
                                    "margin-top": "20px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "20px",
                                          },
                                        },
                                        [_vm._v("Tutar")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "16px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.getPriceDetail().price
                                              ) +
                                              "₺\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "20px",
                                          },
                                        },
                                        [_vm._v("KDV")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "16px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.getPriceDetail().kdvPrice
                                              ) +
                                              "₺\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "20px",
                                          },
                                        },
                                        [_vm._v("Toplam")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-weight": "bold",
                                            "font-size": "16px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.getPriceDetail().totalPrice
                                              ) +
                                              "₺\n                                    "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "20px",
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "center",
                            cursor: "pointer",
                            "font-size": "18px",
                          },
                          on: {
                            click: function ($event) {
                              _vm.showRunningInvoiceDetails =
                                !_vm.showRunningInvoiceDetails
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.showRunningInvoiceDetails
                                  ? "Hide Details"
                                  : "Show Details"
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "billing-section", staticStyle: { width: "100%" } },
          [
            _c(
              "div",
              { staticClass: "content", staticStyle: { width: "100%" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "card",
                    staticStyle: {
                      background: "white",
                      "border-radius": "15px",
                      padding: "25px",
                      border: "none",
                    },
                  },
                  [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("Geçmiş Faturalar"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "bills-content" }, [
                      _c(
                        "div",
                        { staticClass: "bill-table" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "table-head",
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "align-items": "center",
                                "padding-top": "20px",
                              },
                            },
                            [
                              _c("div", [
                                _vm.isAdmin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "bill-search",
                                        on: { click: _vm.createBillModal },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "material-icons" },
                                          [_vm._v("add")]
                                        ),
                                        _vm._v(
                                          "\n                                        Fatura Oluştur\n                                    "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _vm._m(2),
                            ]
                          ),
                          _vm._v(" "),
                          _c("a-table", {
                            attrs: {
                              columns: _vm.columns,
                              "data-source": _vm.invoices,
                              "row-selection": _vm.rowSelection,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "paid",
                                fn: function (text, record) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      record.paid
                                        ? _c("div", {
                                            staticStyle: {
                                              background: "green",
                                              width: "10px",
                                              height: "10px",
                                              "border-radius": "100px",
                                              "margin-right": "5px",
                                            },
                                          })
                                        : _c("div", {
                                            staticStyle: {
                                              background: "red",
                                              width: "10px",
                                              height: "10px",
                                              "border-radius": "100px",
                                              "margin-right": "5px",
                                            },
                                          }),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              record.paid
                                                ? "" + _vm.$t("billing.paid")
                                                : "" + _vm.$t("billing.unPaid")
                                            ) +
                                            "\n                                    "
                                        ),
                                      ]),
                                    ]
                                  )
                                },
                              },
                              {
                                key: "_id",
                                fn: function (text, record) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(record._id.slice(12)) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                },
                              },
                              {
                                key: "price",
                                fn: function (text, record) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    ₺ " +
                                          _vm._s(
                                            _vm.seperateWithCommas(
                                              record.price.toFixed(2)
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                },
                              },
                              {
                                key: "createdDate",
                                fn: function (text, record) {
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.formatDate(record.createdDate)
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                },
                              },
                              {
                                key: "isViewing",
                                fn: function (text, record) {
                                  return _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        "justify-content": "flex-end",
                                      },
                                    },
                                    [
                                      record.pdf
                                        ? _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "margin-right": "10px",
                                                "user-select": "none",
                                                cursor: "pointer",
                                                color: "black",
                                                "text-decoration": "none",
                                              },
                                              attrs: {
                                                href:
                                                  "https://static.supsis.live/" +
                                                  record.pdf,
                                                target: "”_blank”",
                                                download: record.pdf
                                                  .split("/")
                                                  .pop(),
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    "margin-right": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            download\n                                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                                        Fatura\n                                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "margin-right": "10px",
                                            "user-select": "none",
                                            cursor: "pointer",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$router.push(
                                                "/billing/invoice/" + record._id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "material-icons",
                                              staticStyle: {
                                                "font-size": "16px",
                                                "margin-right": "5px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            visibility\n                                        "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                        İncele\n                                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !record.paid
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "margin-right": "10px",
                                                "user-select": "none",
                                                cursor: "pointer",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.paymentBill(
                                                    record._id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    "margin-right": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            paid\n                                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                                        Hemen Öde\n                                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isAdmin
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "margin-right": "10px",
                                                "user-select": "none",
                                                cursor: "pointer",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteInvoice(
                                                    record._id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    "margin-right": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            delete\n                                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                                        Sil\n                                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isAdmin &&
                                      record.paid &&
                                      !record.refund
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "margin-right": "10px",
                                                "user-select": "none",
                                                cursor: "pointer",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.refundInvoice(
                                                    record._id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    "margin-right": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            payments\n                                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                                        Geri Öde\n                                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isAdmin &&
                                      !record.paid &&
                                      !record.refund
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "user-select": "none",
                                                cursor: "pointer",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.markPaidBill(
                                                    record._id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                  staticStyle: {
                                                    "font-size": "16px",
                                                    "margin-right": "5px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            payments\n                                        "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                                        Ödendi\n                                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "information" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("lightbulb")]),
      _vm._v(
        "\n                Şuan deneme sürümündesiniz. Ayrıcalıklı paketleri görmek için deneme sürümünü hemen\n                atlayabilirsiniz.\n            "
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "running-invoice-detail-title" }, [
        _vm._v("Fatura Durumu"),
      ]),
      _vm._v(" "),
      _c("div", [_vm._v("Bekleniyor..")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" download ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }